// Legacy
const slideTypes = [
  {
    name: 'True or False',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'true-or-false',
    desc: 'Swipe through statements and pick True or False',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    canvasUrl: 'http://192.168.1.57:3000/present',
    editorUrl: 'http://192.168.1.57:3000/edit',
    audienceUrl: 'http://192.168.1.57:3000/join',
  },
  {
    name: 'Quiz Hackathon',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'hackathon',
    desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'http://172.20.10.4:3002/present',
    editorUrl: 'http://172.20.10.4:3002/edit',
    audienceUrl: 'http://172.20.10.4:3002/join',
  },
  {
    name: 'Countdown Timer',
    icon: 'fas fa-hourglass-half',
    type: 'hackathon-slide',
    slideType: 'countdownTimer',
    desc: 'Display a customizable countdown timer with title/message for sessions and activities.',
    label: 'Timer',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'https://huong-ahaslides.ngrok.app/present',
    editorUrl: 'https://huong-ahaslides.ngrok.app/edit',
    audienceUrl: 'https://huong-ahaslides.ngrok.app/join',
  },
  {
    name: 'Walking Question',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'hackathon-walking-question',
    desc: 'Participants to submit question and peer answer for other.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'https://don-ahaslides.ngrok.app/presenter',
    editorUrl: 'https://don-ahaslides.ngrok.app/editor',
    audienceUrl: 'https://don-ahaslides.ngrok.app/audience',
  },
  {
    name: 'Pin On Image',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'hackathon-pin-on-image',
    desc: 'Participants must pin on an image to find the final answer.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'http://192.168.1.42:5173/present',
    editorUrl: 'http://192.168.1.42:5173/edit',
    audienceUrl: 'http://192.168.1.42:5173/audience',
  },
  {
    name: 'Random Assignments',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'randomAssignments',
    desc: 'Pick your box and open it to reveal a surprise.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'http://192.168.1.36:5173/present',
    editorUrl: 'http://192.168.1.36:5173/edit',
    audienceUrl: 'http://192.168.1.36:5173/join',
  },
  {
    name: 'Draw',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'hackathon-draw',
    desc: 'Participants draw a picture to find the final answer.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'https://duncan.ngrok.app/present',
    editorUrl: 'https//duncan.ngrok.app/edit',
    audienceUrl: 'https://duncan.ngrok.app/audience',
  },
  {
    name: 'A Deck Of Cards',
    icon: 'fas fa-tasks',
    type: 'hackathon-slide',
    slideType: 'hackathon-deck-of-cards',
    desc: 'Shuffle a deck of cards and let participants pick one card.',
    label: 'Quiz',
    ahaIcon: 'pick-answer',
    ahaIconWhite: 'pick-answer-w',
    preview: 'pickAnswer',
    videoTutorialUrl: 'https://www.youtube.com/embed/BfOV2Rd9soY',
    canvasUrl: 'https://192.168.1.91/present',
    editorUrl: 'https://192.168.1.91/edit',
    audienceUrl: 'https://192.168.1.91/audience',
  },
]

export default slideTypes
